import { validateZipCode } from "@/utils/validations"

export default {
  namespaced: true,

  state: () => ({
    fields: {},
    errors: {},
    formMessage: {
      show: false,
      missingFields: false,
      reviewIssues: false,
    },
  }),

  getters: {
    fields: (state) => state.fields,
    errors: (state) => state.errors,
    formMessage: (state) => state.formMessage,
  },

  mutations: {
    SET_FIELDS(state, payload) {
      state.fields = { ...payload }
    },

    SET_ERRORS(state, errors) {
      state.errors = errors
    },

    SET_FORM_MESSAGE(state, payload) {
      state.formMessage = payload
    },

    CLEAR_FORM_MESSAGE(state) {
      state.formMessage = {
        show: false,
        missingFields: false,
        reviewIssues: false,
      }
    },
  },

  actions: {
    validateJobForm({ commit, state }) {
      const f = state.fields

      const isZipInvalid = f.zip && !validateZipCode(f.zip)

      const errors = {
        name: !f.name ? "This is required" : null,

        zip: !f.zip
          ? "This is required"
          : isZipInvalid
          ? "Please enter a valid ZIP code"
          : null,

        type: !f.type ? "This is required" : null,

        willingToProvidePaidTraining:
          f.willingToProvidePaidTraining === undefined ||
          f.willingToProvidePaidTraining === null
            ? "This is required"
            : null,

        experienceRequired:
          f.experienceRequired === undefined || f.experienceRequired === null
            ? "This is required"
            : null,
      }

      commit("SET_ERRORS", errors)

      const values = Object.values(errors)

      const hasMissingRequired = values.includes("This is required")
      const hasReviewIssues = values.some(
        (msg) => msg && msg !== "This is required"
      )

      commit("SET_FORM_MESSAGE", {
        show: hasMissingRequired || hasReviewIssues,
        missingFields: hasMissingRequired,
        reviewIssues: hasReviewIssues,
      })

      return !(hasMissingRequired || hasReviewIssues)
    },
  },
}
